"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORY_DESCRIPTIONS = exports.CATEGORY_ICONS = exports.CATEGORY_LABELS = exports.AlternativeCategory = void 0;
var AlternativeCategory;
(function (AlternativeCategory) {
    AlternativeCategory["CLOUD"] = "CLOUD";
    AlternativeCategory["STORAGE"] = "STORAGE";
    AlternativeCategory["COMMUNICATION"] = "COMMUNICATION";
    AlternativeCategory["CRM"] = "CRM";
    AlternativeCategory["ANALYTICS"] = "ANALYTICS";
    AlternativeCategory["EMAIL"] = "EMAIL";
    AlternativeCategory["PAYMENTS"] = "PAYMENTS";
    AlternativeCategory["AI"] = "AI";
    AlternativeCategory["DATABASE"] = "DATABASE";
    AlternativeCategory["SECURITY"] = "SECURITY";
    AlternativeCategory["HOSTING"] = "HOSTING";
    AlternativeCategory["PRODUCTIVITY"] = "PRODUCTIVITY";
    AlternativeCategory["PROJECT_MANAGEMENT"] = "PROJECT_MANAGEMENT";
    AlternativeCategory["ECOMMERCE"] = "ECOMMERCE";
    AlternativeCategory["SUPPORT"] = "SUPPORT";
    AlternativeCategory["HR"] = "HR";
    AlternativeCategory["ACCOUNTING"] = "ACCOUNTING";
    AlternativeCategory["LEGAL"] = "LEGAL";
})(AlternativeCategory || (exports.AlternativeCategory = AlternativeCategory = {}));
exports.CATEGORY_LABELS = {
    [AlternativeCategory.CLOUD]: 'Cloud Infrastructure',
    [AlternativeCategory.STORAGE]: 'Storage & CDN',
    [AlternativeCategory.COMMUNICATION]: 'Communication',
    [AlternativeCategory.CRM]: 'CRM & Business',
    [AlternativeCategory.ANALYTICS]: 'Analytics',
    [AlternativeCategory.EMAIL]: 'Email & Marketing',
    [AlternativeCategory.PAYMENTS]: 'Payments',
    [AlternativeCategory.AI]: 'AI & Machine Learning',
    [AlternativeCategory.DATABASE]: 'Database',
    [AlternativeCategory.SECURITY]: 'Security',
    [AlternativeCategory.HOSTING]: 'Web Hosting',
    [AlternativeCategory.PRODUCTIVITY]: 'Productivity & Office',
    [AlternativeCategory.PROJECT_MANAGEMENT]: 'Project Management',
    [AlternativeCategory.ECOMMERCE]: 'E-commerce',
    [AlternativeCategory.SUPPORT]: 'Customer Support',
    [AlternativeCategory.HR]: 'HR & Payroll',
    [AlternativeCategory.ACCOUNTING]: 'Accounting & Invoicing',
    [AlternativeCategory.LEGAL]: 'Legal & Contracts',
};
exports.CATEGORY_ICONS = {
    [AlternativeCategory.CLOUD]: '☁️',
    [AlternativeCategory.STORAGE]: '💾',
    [AlternativeCategory.COMMUNICATION]: '💬',
    [AlternativeCategory.CRM]: '📊',
    [AlternativeCategory.ANALYTICS]: '📈',
    [AlternativeCategory.EMAIL]: '📧',
    [AlternativeCategory.PAYMENTS]: '💳',
    [AlternativeCategory.AI]: '🤖',
    [AlternativeCategory.DATABASE]: '🗄️',
    [AlternativeCategory.SECURITY]: '🔒',
    [AlternativeCategory.HOSTING]: '🌐',
    [AlternativeCategory.PRODUCTIVITY]: '📝',
    [AlternativeCategory.PROJECT_MANAGEMENT]: '📋',
    [AlternativeCategory.ECOMMERCE]: '🛒',
    [AlternativeCategory.SUPPORT]: '🎧',
    [AlternativeCategory.HR]: '👥',
    [AlternativeCategory.ACCOUNTING]: '🧾',
    [AlternativeCategory.LEGAL]: '⚖️',
};
exports.CATEGORY_DESCRIPTIONS = {
    [AlternativeCategory.CLOUD]: 'European cloud computing platforms, VPS, and bare metal servers with full data sovereignty',
    [AlternativeCategory.STORAGE]: 'EU-based cloud storage, backup, and content delivery networks',
    [AlternativeCategory.COMMUNICATION]: 'Secure messaging, video conferencing, and team collaboration tools',
    [AlternativeCategory.CRM]: 'Customer relationship management and business process automation',
    [AlternativeCategory.ANALYTICS]: 'Privacy-first web analytics and data analysis platforms',
    [AlternativeCategory.EMAIL]: 'Email marketing, transactional email, and automation services',
    [AlternativeCategory.PAYMENTS]: 'European payment processing and financial services',
    [AlternativeCategory.AI]: 'European AI models and machine learning platforms with data sovereignty',
    [AlternativeCategory.DATABASE]: 'Managed database services hosted in the European Union',
    [AlternativeCategory.SECURITY]: 'Security, encryption, and privacy tools built in Europe',
    [AlternativeCategory.HOSTING]: 'European web hosting, WordPress hosting, and domain services for SMBs',
    [AlternativeCategory.PRODUCTIVITY]: 'Office suites, document collaboration, and productivity tools',
    [AlternativeCategory.PROJECT_MANAGEMENT]: 'Project planning, task management, and team coordination tools',
    [AlternativeCategory.ECOMMERCE]: 'Online store platforms, shopping carts, and marketplace solutions',
    [AlternativeCategory.SUPPORT]: 'Help desk, ticketing, and customer service platforms',
    [AlternativeCategory.HR]: 'Human resources, payroll, and employee management systems',
    [AlternativeCategory.ACCOUNTING]: 'Invoicing, bookkeeping, and financial management for businesses',
    [AlternativeCategory.LEGAL]: 'Contract management, e-signatures, and legal document tools',
};
